import Result from "slotworks/model/gameplay/records/results/result";
import Point from "slotworks/utils/geom/point";
export class SparkResult extends Result {
    public positions: Point[];
    public emitPositions: Point[];
    public upgrade: boolean;
    public state: number;
}
